
const primary = '#c59d5f';
const secondary = '#434A54';

export {primary, secondary}